<template>
  <div class="row full-height">
    <div
      ref="scrolllist"
      class="col scroll col-no-padding list-col"
      style="height: calc(100% - 40px)"
      @scroll="handleScroll"
    >
      <div class="row library-list px-2">
        <div
          v-for="(ap, key, indexAP) in filteredlist"
          :key="key"
          class="col-6 col-xl-4 mb-3 px-2"
        >
          <CardImage
            :class="{ selected: ap.selected }"
            @click.native.stop="toggleSelect(ap)"
          >
            <div class="image" slot="image" :style="picture(ap)"></div>
            <div
              class="action"
              slot="action"
              v-if="hasPlans(ap) || hasPatrols(ap)"
              @mouseover="showTooltip(ap)"
              @mouseout="closeTooltip"
            >
              <i class="fa fa-map" v-if="hasPlans(ap)"></i>
              <i class="fa fa-history" v-if="hasPatrols(ap)"></i>
            </div>
            <div
              class="tooltip right"
              :class="{ show: ap.show }"
              v-if="hasPlans(ap) || hasPatrols(ap)"
              v-on-clickaway="closeTooltip"
            >
              <template v-if="hasPlans(ap)">
                <span>{{ $t("ap.library.plansDetail") }}</span>
                <ul>
                  <li v-for="plan in ap.plans">{{ plan.name }}</li>
                </ul>
              </template>
              <template v-if="hasPatrols(ap)">
                <span>{{ $t("ap.library.patrolDetail") }}</span>
                <ul>
                  <li v-for="patrol in ap.patrols">{{ patrol }}</li>
                </ul>
              </template>
            </div>
            <div class="content">
              <div class="col-left">
                <i :class="icons(ap.type)"></i>
              </div>
              <div class="col-right">
                <strong>{{ ap.name }}</strong>
                <span>{{ $t(typeLabel(ap.type)) }}</span>
              </div>
              <div
                class="col-qrcode"
                v-if="ap.type == 2 || ap.type == 4 || ap.type == 5"
              >
                <span
                  v-if="ap.type == 4"
                  class="qrcode-button"
                  v-can="'beepiz-readQRCode-library'"
                  @click.stop="showQRCodeViewer(ap)"
                  :title="$t('ap.titles.modalQRCodeViewer')"
                >
                  <i class="fa fa-eye"></i>
                </span>
                <span
                  v-if="ap.type == 5 || ap.type == 2"
                  class="battery-info"
                  :title="ap.battery === null ? $t('ap.batteryNoInfo') : ''"
                >
                  <i
                    class="fa"
                    :class="{
                      'no-battery-info': ap.battery === null,
                      'battery-ok fa-battery': ap.battery >= 2400,
                      'battery-warning fa-battery-half':
                        ap.battery >= 1700 && ap.battery < 2400,
                      'battery-ko fa-battery-empty': ap.battery < 1700,
                    }"
                  ></i>
                </span>
              </div>
            </div>
            <div v-if="ap.last_detection_at" class="text-muted text-sm mt-3">
              {{
                lastDetectionAt(
                  ap.last_detection_at.date,
                  ap.last_detection_at.timezone
                )
              }}
            </div>
          </CardImage>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Vue from "vue";
import Icons from "@/services/iconMapping.js";
import Rules from "@/services/apRules.js";
import CardImage from "@/components/ui/cards/CardImage";
import Utils from "@/services/utils.js";
import LoadingInline from "@/components/ui/LoadingInline";
import { mixin as clickaway } from "vue-clickaway";
import pickBy from "lodash/pickBy";
import QRCodeViewer from "@/views/actionpoints/library/QRCodeViewer";
import moment from "moment";
import "moment-timezone";
import {useDvFlag} from "../../../services/featureFlag";

export default {
  beforeCreate: function () {},
  beforeDestroy: function () {},
  beforeMount: function () {},
  beforeUpdate: function () {},
  components: {
    CardImage,
    LoadingInline,
  },
  mixins: [clickaway],
  computed: {
    filteredlist: function () {
      var vThis = this;
      var newArray = pickBy(this.list, function (obj, key) {
        if (vThis.filter == "") {
          return true;
        } else {
          var filterOk = Utils.sanitize(obj.name).indexOf(vThis.filter.q) != -1;
          for (var filter in vThis.filter) {
            if (filter != "q" && !vThis.filter[filter]) {
              for (var i = 0; i < Rules.reverseTypes[filter].length; i++) {
                if (obj.type == Rules.reverseTypes[filter][i]) {
                  filterOk = false;
                  break;
                }
              }
            }
          }
          return filterOk;
        }
      });
      return newArray;
    },
  },
  created: function () {},
  data() {
    return {
      lockScrollLoading: false,
    };
  },
  destroyed: function () {},
  methods: {
    picture: function (ap) {
      if (ap.picture == null || ap.picture == "") {
        return "background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgOTEgOTEiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDkxIDkxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6I0QxRDNEMzt9PC9zdHlsZT48Zz48cGF0aCBjbGFzcz0ic3QwIiBkPSJNNTUsNDUuM2MwLTQuNy0zLjgtOC41LTguNS04LjVTMzgsNDAuNiwzOCw0NS4zczguNSwxMy41LDguNSwxMy41UzU1LDUwLDU1LDQ1LjN6IE00Mi41LDQ1LjFjMC0yLjIsMS44LTQsNC00czQsMS44LDQsNGMwLDIuMi0xLjgsNC00LDRDNDQuMyw0OS4xLDQyLjUsNDcuMyw0Mi41LDQ1LjF6Ii8+PC9nPjwvc3ZnPg==)";
      }
      return "background-image: url(" + ap.picture + ")";
    },
    byColumn: function (tags, totalColumns, columnNumber) {
      var i = 0;
      var newArray = pickBy(tags, function (obj, key) {
        var cond = i % totalColumns === columnNumber - 1;
        i++;
        return cond;
      });
      return newArray;
    },
    hasPlans: function (ap) {
      return ap.plans != null && ap.plans.length > 0;
    },
    hasPatrols: function (ap) {
      return ap.patrols != null && ap.patrols.length > 0;
    },
    showTooltip: function (ap) {
      this.closeTooltip();
      ap.show = !ap.show;
    },
    closeTooltip: function () {
      var ap = null;
      for (var i = 0; i < this.list.length; i++) {
        ap = this.list[i];
        if (ap.show && !ap.firstTime) {
          ap.show = false;
          ap.firstTime = true;
        } else {
          ap.firstTime = false;
        }
      }
    },
    toggleSelect: function (ap) {
      if (!this.multiselect) {
        this.unselectAll(ap);
      }
      ap.selected = !ap.selected;
      if (ap.selected) {
        this.$emit("apSelect", ap);
      } else {
        this.$emit("apUnselect", ap);
      }
    },
    unselectAll: function (toKeep) {
      for (var item in this.list) {
        if (
          toKeep == null ||
          (toKeep != null && this.list[item].id != toKeep.id)
        ) {
          this.list[item].selected = false;
        }
      }
    },
    icons: function (typeId) {
      return Icons.actionpoints[typeId];
    },
    typeLabel: function (typeId) {
      return "ap.types." + Rules.types[typeId];
    },
    handleScroll: function (e) {
      if (!this.lockScrollLoading) {
        if (
          e.target.scrollTop ==
          e.target.scrollHeight - e.target.offsetHeight
        ) {
          this.$refs.loading.show();
          this.lockScrollLoading = true;
          this.$emit("next");
        }
      }
    },
    unlockScroll: function () {
      this.lockScrollLoading = false;
      this.$refs.loading.hide();
    },
    scrollToTop() {
      this.$refs.scrolllist.scrollTop = 0;
    },
    showQRCodeViewer: function (ap) {
      window.Vfc.modalProps = {
        title: Utils.t("ap.titles.modalQRCodeViewer"),
        width: "450px",
        height: "600px",
      };
      window.Vfc.modalComponentProps = {
        ap: ap,
      };
      window.Vfc.modalComponent = QRCodeViewer;
      window.Vfc.blurMode(true);
      window.Vfc.$refs.modal.show();
    },
    lastDetectionAt(date, timezone) {
      return Utils.t("ap.titles.lastDetectionAt", {
        date: moment.tz(date, timezone).local().format("DD/MM/YYYY"),
        time: moment.tz(date, timezone).local().format("HH:mm"),
      });
    },
  },
  mounted: function () {
    const flag = useDvFlag('beepiz-action-point-can:read');
    if (!flag.access && flag.fallback==="no_plan") {
      this.$router.push({ name: 'AccessDenied', params: { slug: "actionpoints-library"} })
    }
    else if (!flag.access && flag.fallback==="no_role") {
      this.$router.push({ name: 'AccessDenied', params: { slug: "actionpoints-library_no_role"} })
    }
  },
  name: "",
  props: {
    list: {
      type: [Array],
      default: function () {
        return [];
      },
    },
    chrome: {
      default: true,
      type: [Boolean],
    },
    multiselect: {
      type: Boolean,
      default: true,
    },
    filter: {
      type: Object,
      default: function () {
        return {
          q: "",
          wifi: true,
          beacon: true,
          nfc: true,
          qrcode: true,
        };
      },
    },
  },
  updated: function () {},
  watch: {
    list: function () {
      for (var item in this.list) {
        Vue.util.defineReactive(this.list[item], "show", false);
        Vue.util.defineReactive(this.list[item], "firstTime", false);
        Vue.util.defineReactive(this.list[item], "selected", false);
      }
      this.filteredList = this.list;
    },
  },
};
</script>

<style lang="scss" scoped></style>
